(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["header"]) return;
  try {
    

  $(".nav-hamburger").on('click', function(){
    $("header nav").toggleClass("open");
    $(".extended-nav-menu").toggleClass("open");
    $("header button.nav-hamburger").toggleClass("show");
  });


  $(window).scroll(function() {
    if($(window).scrollTop() >= $('.announcement-bar').height() ) {
      $('header').addClass('active');
    } else {
      $('header').removeClass('active');
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"]) return;
  try {
    

  $(document).ready(function(){
    $(".map").hide();
    $(".map:first-of-type").show();
  });

  $('.store-buttons button').on('click', function(){
    button_id = $(this).attr('data-id');
    $(".map").hide();
    $('#' + button_id).show();
  });


  } catch(e) { console.error(e); }
})();

})();
